import { gql } from "@apollo/client";

const importOneononeCandidatesQuery = gql`
  query importOneononeCandidatesQuery($reportUserId: Int!) {
    importOneononeCandidates(reportUserId: $reportUserId) {
      id
      startDatetime
    }
  }
`;

export default importOneononeCandidatesQuery;
